export default [
    {
        path: "responsables-planilla",
        name: "responsables-planilla",
        component: () => import("../views/PlanillaResponsables.vue")
    }
]